<template>
  <div class="blog-detail service-portlet">
    <div class="container">
      <div class="blog-listing">
        <!-- Content Area -->

        <article class="type-post">
          <!--<div class="entry-cover">-->
          <!--<img src="static/images/blog/1/1.png">-->
          <!--</div>-->
          <div class="blog-detail-contentbox">
            <h3>구내식당 고객 만족도 조사 서비스 "런치스타" 출시</h3>
            <p class="post-date"><span class="font-color-afblue">Posted at </span>06.30, 2018</p>
            <div class="contentbox-body">
              <p>
                런치스타는
                구내식당 이용자를 대상으로 하는 상시 설문 조사 시스템입니다.
                기존의 설문조사 방식이나, 스티커 방식의 번거로운 방식을 탈피하여, 매
                식수별 이용자들의 만족정도를 수집 할 수 있습니다.
                런치스타는 수집된 정보를 바탕으로 다양한 통계를 제공합니다. 제공되는
                통계 정보를 바탕으로 식당 운영자들은 이용자들의 만족정도를 쉽게
                분석하여, 구내식당 운영에 필요한 개선항목을들 명확하게 파악할 수
                있습니다.
              </p>
              <div class="imagebox">
                <img src="static/images/blog/1/2.png">
                <p>런치스타 키오스크</p>
              </div>
              <p>
                한국기술교육대학교에 런치스타를 설치하였습니다. 퇴식구 또는 출구 쪽에 설치하여 식사를 마친 학생들이 손쉽게 만족도 조사에 참여할 수 있습니다. 매 식수별 조사가 이루어지므로 기존의 설문방식보다 현저히 높은 참여를 이끌어낼 수 있습니다.
              </p>
              <div class="imagebox">
                <img src="static/images/blog/1/3.png">
                <p>런치스타 웹기반 만족도 통계 분석 시스템</p>
              </div>
              <p>
                런치스타는 웹기반으로 운영되는 통계분석 시스템을 내장하고
                있습니다. 사용자들의 참여 정보를 바탕으로 식당의 품질을 개선할 수
                있는 다양한 정보를 제공합니다.
              </p>
              <ul>
                <li>만족도 변화 그래프</li>
                <li>조사 참여 인원 변화 그래프</li>
                <li>여러 식당을 운영할 때 식당별 만족도 순위</li>
                <li>지난기간 대비 만족도 향상 정도의 표시</li>
                <li>만족도가 높은 메뉴와 만족도가 낮은 메뉴의 순위</li>
              </ul>
              <p>
                맛있는 구내식당 만들기 이제 런치스타와 합께 만들어보세요.
              </p>
            </div>
          </div>
          <div class="tags">
            <h3 class="block-title">homepage : </h3>
            <a href="http://www.lunchstar.co.kr/" target="_blank" >www.lunchstar.co.kr</a>
            <ul>

            </ul>
          </div>

        </article>

        <!-- Related Post -->
        <div class="related-post">
          <h3 class="block-title">recent blog</h3>
          <div class="row">
            <div class="row-3">
              <article class="type-post">
                <div class="entry-cover">
                  <a title="Cover" v-on:click="goBlogDetail(2)"><img src="static/images/blog/2/2.png"></a>
                </div>
                <div class="entry-contentbox">
                  <div class="entry-title">
                    <a title="Single post with image" v-on:click="goBlogDetail(2)"><h3>i-award smart app award 건강/의료분야  대상 수상</h3></a>
                  </div>
                  <p class="post-date"><span class="font-color-afblue">Posted at </span>12.07, 2017</p>
                </div>
              </article>
            </div>
            <div class="row-3">
              <article class="type-post">
                <div class="entry-cover">
                  <a title="Cover" v-on:click="goBlogDetail(3)"><img src="static/images/blog/3/3.png"></a>
                </div>
                <div class="entry-contentbox">
                  <div class="entry-title">
                    <a title="Single post with image" v-on:click="goBlogDetail(3)"><h3>영상 제작 어플리케이션 스냅무비 다운로드
                      500만명 돌파</h3></a>
                  </div>
                  <p class="post-date"><span class="font-color-afblue">Posted at </span>12.13, 2016</p>
                </div>
              </article>
            </div>
            <!--<div class="row-3">-->
            <!--<article class="type-post">-->
            <!--<div class="entry-cover">-->
            <!--<a title="Cover" href="blog_detai_1.html"><img src="static/images/blog/1/1.png"></a>-->
            <!--</div>-->
            <!--<div class="entry-contentbox">-->
            <!--<div class="entry-title">-->
            <!--<a title="Single post with image" href="blog_detai_1.html"><h3>식당 고객  만족도 조사 서비스 런치스타 출시</h3></a>-->
            <!--</div>-->
            <!--<p class="post-date"><span class="font-color-afblue">Posted at </span>06.30, 2018</p>-->
            <!--</div>-->
            <!--</article>-->
            <!--</div>-->
          </div>
        </div><!-- Related Post /- -->
      </div><!-- Content Area /- -->

    </div>
  </div><!-- Blog /- -->
</template>

<script>
  export default {
    name: 'Blog1',
    data () {
      return {
        msg: 'Welcome to Your Vue.js App'
      }
    },
    methods: {
      goBlogDetail( no ) {
        this.$router.push("Blog"+ no )
        //console.log('## click menu : ' + title)
        //this.menuVisible = false
        //this.$emit('clicked',title)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Blog1.vue